import { useContext } from 'react';
import { OneSignalContext } from '@/common/providers/oneSignalContext';

/**
 * Access OneSignal push state and actions from OneSignalProvider.
 */
export function useOneSignal() {
  const context = useContext(OneSignalContext);
  if (!context) {
    throw new Error('useOneSignal must be used within OneSignalProvider');
  }
  return context;
}
